import { createContext } from 'react';
import type { ModalCallbacks } from './types';

const ModalContext = createContext<ModalCallbacks>({
  open: () => {},
  close: () => {},
});

export default ModalContext;
